import React, { useState, useEffect } from 'react';
import service from '../../services/service';
import authService from '../../services/authService';

const WalletStats = () => {
    const [data, setData] = useState({
        totalBalance: 0,
        totalBalanceT: 0,
        withdrawalBalance: 0,
        totalCommission: 0,
        onHoldBalance: 0,
        trialBalance: 0
    });
    const [totalBookings, setTotalBookings] = useState(0);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    useEffect(() => {
        getWalletStats();
    }, []);

    const getWalletStats = async () => {
        try {
            setLoading(true);
            setError('');
            const isLoggedIn = sessionStorage.getItem('isLoggedIn') === 'true';
            const userId = sessionStorage.getItem('userId');

            if (!isLoggedIn || !userId) {
                throw new Error('Please log in to view wallet statistics');
            }

            const [walletResponse, userDetail] = await Promise.all([
                service.save({ userId }, "wallet/stats"),
                authService.getUserDetailsById(userId)
            ]);

            if (userDetail?.success) {
                setTotalBookings(userDetail.totalBookings);
            }

            if (walletResponse?.success) {
                setData(walletResponse.data);
            } else {
                throw new Error(walletResponse?.message || 'Failed to fetch wallet data');
            }
        } catch (error) {
            setError(error.message);
        } finally {
            setLoading(false);
        }
    };

    const cards = [
        {
            title: 'Trial Balance',
            value: data.trialBalance,
            color: 'info',
            icon: '🧪'
        },
        {
            title: 'Commission',
            value: data.totalCommission.toFixed(2),
            color: 'danger',
            icon: '💵'
        },
        {
            title: 'Total Balance',
            value: data.totalBalanceT.toFixed(2),
            color: 'success',
            icon: '💰'
        },
        {
            title: 'Total Bookings',
            value: totalBookings,
            color: 'secondary',
            icon: '📅'
        },
        {
            title: 'Withdrawable Balance',
            value: (data.onHoldBalance + data.totalBalanceT).toFixed(2),
            color: 'primary',
            icon: '⬇️'
        },
        {
            title: 'On Hold Balance',
            value: data.onHoldBalance > 0 ? `-${data.onHoldBalance}` : `${data.onHoldBalance}`,
            color: 'warning',
            icon: '⏳'
        }
    ];

    if (loading) {
        return (
            <div className="d-flex justify-content-center align-items-center p-5">
                <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                </div>
            </div>
        );
    }

    return (
        <div className="container py-4">
            {error && (
                <div className="alert alert-danger" role="alert">
                    {error}
                </div>
            )}

            <div className="row g-4">
                {cards.map((card, index) => (
                    <div key={index} className="col-12 col-md-6 col-lg-4">
                        <div className={`card h-100 border-0 shadow-sm`}>
                            <div className="card-body">
                                <div className="d-flex align-items-center">
                                    <div className={`bg-${card.color} bg-opacity-10 p-3 rounded-3 me-3`}>
                                        <span style={{ fontSize: '1.5rem' }}>{card.icon}</span>
                                    </div>
                                    <div>
                                        <h6 className={`text-${card.color} mb-1`}>
                                            {card.title}
                                        </h6>
                                        <h4 className="mb-0">
                                            {card.title !== 'Total Bookings' ? `₹ ${card.value}` : card.value}
                                        </h4>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>

            {/* <div className="text-end mt-4">
                <button 
                    className="btn btn-primary"
                    onClick={getWalletStats}
                    disabled={loading}
                >
                    Refresh Stats
                </button>
            </div> */}
        </div>
    );
};

export default WalletStats;